import { IApplicationState } from '../../types/redux';

export const getBuilderChatContact = (state: IApplicationState) => state.builderChat.chatContact;
